import { queryOptions } from "@tanstack/react-query";
import { QUERY_KEYS } from "@/models";
import {
	getBggCollectionCall,
	getGameCall,
	getGameExpansionsCall,
	getGameSessionsCall,
	getGameStatisticsCall,
	getGamesCall,
	getShameStatisticsCall,
	getShamesCall,
} from "../gameService";
import {
	createEntityQuery,
	createEntityQueryWithKeys,
	createListQuery,
	createNestedQuery,
	createNestedQueryWithKeys,
} from "./queryFactory";

export const getGames = createListQuery(QUERY_KEYS.games, getGamesCall);

export const getGame = createEntityQuery(QUERY_KEYS.game, getGameCall);

export const getGameExpansions = createNestedQuery(QUERY_KEYS.game, QUERY_KEYS.expansions, getGameExpansionsCall);

export const getGameStatistics = createNestedQuery(QUERY_KEYS.game, QUERY_KEYS.statistics, getGameStatisticsCall);

export const getGameSessions = createNestedQuery(QUERY_KEYS.game, QUERY_KEYS.sessions, getGameSessionsCall);

export const getGameSessionsShortList = createNestedQueryWithKeys(
	QUERY_KEYS.game,
	QUERY_KEYS.sessions,
	[QUERY_KEYS.shortlist],
	getGameSessionsCall,
);

export const getBggCollection = (username: string) =>
	queryOptions({
		queryKey: [QUERY_KEYS.game, QUERY_KEYS.bgg, username],
		queryFn: () => getBggCollectionCall(username),
		retry: false,
	});

export const getShames = createListQuery(QUERY_KEYS.shames, getShamesCall);

export const getShameStatistics = createEntityQueryWithKeys(
	[QUERY_KEYS.shames, QUERY_KEYS.statistics],
	getShameStatisticsCall,
);
